import { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import Stats from './components/Stats';
import Footer from './components/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [appointmentSubmitted, setAppointmentSubmitted] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleAppointmentSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    
    const name = formData.get('name') as string;
    const email = formData.get('email') as string;
    const phone = formData.get('phone') as string;
    const date = formData.get('date') as string;
    const time = formData.get('time') as string;

    if (!name || !email || !phone || !date || !time) {
      alert('Lütfen tüm alanları doldurun.');
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d6557b1of4o2fjfo9dl0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setAppointmentSubmitted(true);
        form.reset();
      }
    } catch (error) {
      alert('Bir hata oluştu. Lütfen tekrar deneyin.');
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header isScrolled={isScrolled} />
      <Hero />
      <Services />
      <WhyUs />
      <Stats />

      {/* Randevu Al Bölümü */}
      <section id="randevu" className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#FFCE00]/10 rounded-full mb-4">
                <i className="ri-calendar-check-line text-[#DD0000]"></i>
                <span className="text-[#1a1a1a] text-sm font-semibold">Ücretsiz Danışmanlık</span>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold text-[#1a1a1a] mb-4">
                Randevu <span className="text-[#DD0000]">Alın</span>
              </h2>
              <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                Almanya'da eğitim hayalinizi gerçekleştirmek için ilk adımı atın. Ücretsiz danışmanlık randevusu alın.
              </p>
            </div>

            {appointmentSubmitted ? (
              <div className="bg-green-50 border border-green-200 rounded-xl p-8 text-center">
                <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-check-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-[#1a1a1a] mb-2">Randevunuz Alındı!</h3>
                <p className="text-gray-600">En kısa sürede sizinle iletişime geçeceğiz.</p>
              </div>
            ) : (
              <form 
                id="appointment-form"
                data-readdy-form
                onSubmit={handleAppointmentSubmit}
                className="bg-white border border-gray-200 rounded-2xl p-8 shadow-sm"
              >
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="appointment-name" className="block text-sm font-semibold text-[#1a1a1a] mb-2">
                      Ad Soyad *
                    </label>
                    <input
                      type="text"
                      id="appointment-name"
                      name="name"
                      required
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-[#1a1a1a] placeholder-gray-400 focus:ring-2 focus:ring-[#DD0000] focus:border-transparent"
                      placeholder="Adınız ve soyadınız"
                    />
                  </div>
                  <div>
                    <label htmlFor="appointment-email" className="block text-sm font-semibold text-[#1a1a1a] mb-2">
                      E-posta *
                    </label>
                    <input
                      type="email"
                      id="appointment-email"
                      name="email"
                      required
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-[#1a1a1a] placeholder-gray-400 focus:ring-2 focus:ring-[#DD0000] focus:border-transparent"
                      placeholder="ornek@email.com"
                    />
                  </div>
                  <div>
                    <label htmlFor="appointment-phone" className="block text-sm font-semibold text-[#1a1a1a] mb-2">
                      Telefon *
                    </label>
                    <input
                      type="tel"
                      id="appointment-phone"
                      name="phone"
                      required
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-[#1a1a1a] placeholder-gray-400 focus:ring-2 focus:ring-[#DD0000] focus:border-transparent"
                      placeholder="+90 5XX XXX XX XX"
                    />
                  </div>
                  <div>
                    <label htmlFor="appointment-service" className="block text-sm font-semibold text-[#1a1a1a] mb-2">
                      İlgilendiğiniz Hizmet
                    </label>
                    <select
                      id="appointment-service"
                      name="service"
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-[#1a1a1a] focus:ring-2 focus:ring-[#DD0000] focus:border-transparent"
                    >
                      <option value="Genel Danışmanlık">Genel Danışmanlık</option>
                      <option value="Lisans Programları">Lisans Programları</option>
                      <option value="Yüksek Lisans">Yüksek Lisans</option>
                      <option value="Dil Okulu">Dil Okulu</option>
                      <option value="Vize İşlemleri">Vize İşlemleri</option>
                      <option value="Konaklama">Konaklama</option>
                    </select>
                  </div>
                  <div>
                    <label htmlFor="appointment-date" className="block text-sm font-semibold text-[#1a1a1a] mb-2">
                      Tercih Ettiğiniz Tarih *
                    </label>
                    <input
                      type="date"
                      id="appointment-date"
                      name="date"
                      required
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-[#1a1a1a] focus:ring-2 focus:ring-[#DD0000] focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label htmlFor="appointment-time" className="block text-sm font-semibold text-[#1a1a1a] mb-2">
                      Tercih Ettiğiniz Saat *
                    </label>
                    <select
                      id="appointment-time"
                      name="time"
                      required
                      className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-[#1a1a1a] focus:ring-2 focus:ring-[#DD0000] focus:border-transparent"
                    >
                      <option value="">Saat seçin</option>
                      <option value="09:00">09:00</option>
                      <option value="10:00">10:00</option>
                      <option value="11:00">11:00</option>
                      <option value="12:00">12:00</option>
                      <option value="14:00">14:00</option>
                      <option value="15:00">15:00</option>
                      <option value="16:00">16:00</option>
                      <option value="17:00">17:00</option>
                    </select>
                  </div>
                </div>
                <button
                  type="submit"
                  className="w-full mt-8 px-8 py-4 bg-[#DD0000] text-white font-bold text-lg rounded-lg hover:bg-[#bb0000] transition-all whitespace-nowrap cursor-pointer"
                >
                  Randevu Talep Et
                </button>
              </form>
            )}
          </div>
        </div>
      </section>

      {/* İletişim CTA */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] mb-4">
              Bize <span className="text-[#DD0000]">Ulaşın</span>
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Sorularınız için bize ulaşın, size yardımcı olmaktan mutluluk duyarız.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-3xl mx-auto">
            <a
              href="tel:+902129126797"
              className="flex items-center gap-4 p-6 bg-white rounded-xl border border-gray-200 hover:border-[#DD0000]/30 hover:shadow-md transition-all cursor-pointer"
            >
              <div className="w-14 h-14 bg-[#DD0000] rounded-xl flex items-center justify-center">
                <i className="ri-building-line text-2xl text-white"></i>
              </div>
              <div>
                <div className="text-sm text-gray-500">Ofis</div>
                <div className="font-bold text-[#1a1a1a]">0212 912 67 97</div>
              </div>
            </a>
            <a
              href="mailto:rotaberlinn@gmail.com"
              className="flex items-center gap-4 p-6 bg-white rounded-xl border border-gray-200 hover:border-[#DD0000]/30 hover:shadow-md transition-all cursor-pointer"
            >
              <div className="w-14 h-14 bg-[#1a1a1a] rounded-xl flex items-center justify-center">
                <i className="ri-mail-line text-2xl text-white"></i>
              </div>
              <div>
                <div className="text-sm text-gray-500">E-posta</div>
                <div className="font-bold text-[#1a1a1a]">rotaberlinn@gmail.com</div>
              </div>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
